var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('acgn-statistic-detail',{attrs:{"onlyOverdue":true,"userId":_vm.userId,"comicId":_vm.comicId,"exportCode":"6005"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }